/**
 * Forbrukerrådet - Kommunetesten
 * @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
 * @author Anders Evenrud <anders.evenrud@copyleft.no>
 */

export default {
  methods: {
    decimalLabel (num) {
      return isNaN(num) || num === -1
        ? 'I/T'
        : parseFloat(num)
          .toFixed(1)
          .replace('.', ',')
    }
  }
}
